<template>
  <div v-loading="loading" class="diy-dialog">
    <div class="dialog-title">填写小程序信息</div>
    <div class="drop-out" @click="closeFun">
      <img alt="" :src="g_imgSrc.delete" class="out" @click="closeFun" />
    </div>
    <div class="dialog-content">
      <!-- <p style="margin-bottom: 20px; color: grey">
        *仅适用于公众号文章推送的场景，并且必须是具备微信支付权限的公众号才可以使用
      </p> -->
      <el-form label-width="100px" :model="form" label-position="left">
        <el-form-item label="小程序app id">
          <el-input
            v-model.trim="form.appid"
            type="text"
            show-word-limit
            maxlength="36"
            placeholder="小程序应用"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="小程序账号">
          <el-input
            v-model.trim="form.username"
            type="text"
            show-word-limit
            maxlength="36"
            placeholder="小程序原始id，即小程序对应的以gh_开头的id"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="小程序路径">
          <el-input
            v-model.trim="form.path"
            type="text"
            show-word-limit
            maxlength="1024"
            placeholder="小程序内页面路径及参数"
          ></el-input>
        </el-form-item>
        <el-form-item label="展示方式">
          <el-radio-group v-model="form.type">
            <el-radio label="1">文字</el-radio>
            <el-radio label="2">图片</el-radio>
            <el-radio label="3">小程序卡片</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 文字 -->
        <el-form-item label="文字内容" v-if="form.type === '1'">
          <el-input v-model.trim="form.dynamic1"></el-input>
          <p class="desc-text">点击文字会打开小程序指定路径的页面</p>
        </el-form-item>
        <!-- 图片 -->
        <el-form-item label="图片" v-if="form.type === '2'">
          <p class="desc-text">点击图片会打开小程序指定路径的页面</p>
          <!-- <el-button>上传图片</el-button> -->
          <el-button @click="dialogVisible = true">从图片库选择</el-button>
          <div v-show="form.dynamic2.url" class="tab2-img">
            <img :src="form.dynamic2.url" :alt="form.dynamic2.mate_name" />
            <a href="javascript:void(0);" class="delete" @click="tab2Delete">删除</a>
          </div>
        </el-form-item>
        <!-- 小程序卡片 -->
        <el-form-item label="卡片标题" v-if="form.type === '3'">
          <el-input
            v-model.trim="form.dynamic3.title"
            type="text"
            show-word-limit
            maxlength="35"
          ></el-input>
          <p class="desc-text">点击小程序卡片会打开小程序路径指定的页面</p>
        </el-form-item>
        <el-form-item label="卡片样式" v-if="form.type === '3'">
          <div class="mini-card">
            <div class="up-box">
              <p class="card-title">{{ form.dynamic3.title }}</p>
            </div>
            <div class="center-box">
              <div class="center">
                <p v-show="!form.dynamic3.url" class="tip">
                  建议图片尺寸为5:4，大小不超过10M，暂不支持动图。
                </p>
                <el-button @click="dialogVisible = true" class="tab3-btn">从图片库选择</el-button>
                <div v-show="form.dynamic3.url" class="tab3-img">
                  <img class="image" :src="form.dynamic3.url" :alt="form.dynamic3.mate_name" />
                </div>
              </div>
            </div>
            <div class="bottom-box">
              <!-- <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAb1BMVEUAAAB4it11h9x2h9x2h9x2htx8j+R8i+B1h9x2h9x3h92Snv91htt2h9x1h9x4h9x1h9x1h9x2idx1h9t2h9t1htt1h9x1h9x1htx2h9x1h912h9x4h913iN17juOOjuN1iNx2h9t4h958i+B1htvejBiPAAAAJHRSTlMALPLcxKcVEOXXUgXtspU498sx69DPu5+Yc2JeRDwbCYuIRiGBtoolAAAA3ElEQVQoz62S1xKDIBBFWYiFYImm2DWF///G7DJEROOb58U79zi4O8iOo8zuCRfV8EdFgbYE49qFQs8ksJInajOA1wWfYvLcGSueU/oUGBtPpti09uNS68KTMcrQ5jce4kmN/HKn9XVPAo702JEdx9hTUrWUqVrI3KwUmM1NhIWMKdwiGvpGMWZOAj1PZuzAxHwhVSplrajoseBnbyDHAwvrtvKKhdqTtFBkL8wO5ijcsS3G1JMNvQ5mdW7fc0x0+ZcnlJlZiflAomdEyFaM7qeK2JahEjy5ZyU7jC/q/Rz/DgqEuAAAAABJRU5ErkJggg=="
                alt="#"
                class="mini-logo"
              /> -->
              <span>小程序</span>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <!-- 图片 -->
      <el-dialog
        class="release-dialog"
        :visible.sync="dialogVisible"
        :show-close="false"
        width="990px"
        append-to-body
      >
        <Imgdialog
          :imgclose="closeimg"
          @imgDatalist="imgSubmit"
          :img-id-list="imgIdList"
          type="public"
          :is-radio="true"
        />
      </el-dialog>
    </div>

    <div slot="footer" class="dialog-footer" v-if="true">
      <el-button class="closeCancel" @click="closeFun">取 消</el-button>
      <el-button type="primary" @click="sureFun">确 定</el-button>
    </div>
  </div>
</template>
<script>
import Imgdialog from './dialog.vue';
const defaultForm = {
  appid: '',
  username: '',
  path: '',
  type: '1',
  dynamic1: '',
  dynamic2: {
    url: '',
  },
  dynamic3: {
    title: '',
    url: '',
  },
};
export default {
  components: { Imgdialog },
  props: {
    type: {
      type: String,
      default: 'public',
    },
    dialogClose: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      loading: false, // loading
      dialogVisible: false,
      form: JSON.parse(JSON.stringify(defaultForm)),
      imgIdList: [],
    };
  },
  mounted() {},
  methods: {
    closeFun() {
      this.dialogClose();
      this.form = JSON.parse(JSON.stringify(defaultForm));
    },
    sureFun() {
      this.$emit('emitSubmit', JSON.parse(JSON.stringify(this.form)));
      this.dialogClose();
    },
    // 图片库选择图片后 -- 保存
    imgSubmit(list) {
      if (!list.length) {
        this.$message('请选择一张图片');
        this.dialogVisible = true;
        return;
      }
      const temp = list.map((item) => {
        let wxMediaUrl = '';
        const { apps } = item;
        for (let index = 0; index < apps.length; index++) {
          const element = apps[index];
          if (element.wx_media_url) {
            wxMediaUrl = element.wx_media_url;
            break;
          }
        }
        const obj1 = {
          mate_id: item.mate_id,
          mate_name: item.mate_name,
          url: wxMediaUrl,
          mate_data: item.mate_data,
          public_list: item.apps,
          agent_list: [],
        };
        return obj1;
      });
      if (this.form.type === '2') {
        this.form.dynamic2 = { ...temp[0] };
      } else {
        this.form.dynamic3 = { title: this.form.dynamic3.title, ...temp[0] };
      }
    },
    // 关闭图片库
    closeimg() {
      this.dialogVisible = false;
    },
    // 删除tab2的图片
    tab2Delete() {
      this.form.dynamic2 = { url: '' };
    },
  },
};
</script>
<style scoped lang="scss">
.diy-dialog {
  .dialog-title {
    font-size: 16px;
    margin-left: 32px;
  }
  .drop-out {
    height: 18px;
    width: 20px;
    position: absolute;
    top: 30px;
    right: 45px;
    cursor: pointer;
    .out {
      width: 100%;
      cursor: pointer;
    }
  }

  .dialog-content {
    padding: 32px;
    width: 650px;
    .desc-text {
      color: #7e8081;
    }

    // 上传图片
    .tab2-img {
      width: fit-content;
      margin-top: 32px;
      .delete {
        visibility: hidden;
      }
      &:hover {
        .delete {
          text-decoration: none;
          color: #576b95;
          display: inline-block;
          padding-left: 16px;
          visibility: visible;
        }
      }
      img {
        max-width: 100px;
        max-height: 100px;
      }
    }

    // 卡片样式
    .mini-card {
      width: 270px;
      background-color: #f6f7f8;
      border: 1px solid #e3e4e5;
      border-radius: 2px;
      .up-box {
        padding: 10px 15px 0;
        .card-title {
          display: block;
          line-height: 24px;
          padding-bottom: 10px;
          font-weight: 400;
        }
      }
      .center-box {
        padding: 0 15px 15px;
        .center {
          position: relative;
          border: 1px dashed #e3e4e5;
          text-align: center;
          height: 180px;
          box-sizing: border-box;
          background-color: #fff;
          .tip {
            display: block;
            line-height: 24px;
            padding: 20px 10px;
            color: #7e8081;
            word-break: break-word;
          }
          // 上传卡片
          .tab3-btn {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            z-index: 1;
          }
          &:hover {
            .tab3-btn {
              z-index: 3;
            }
            .tab3-img {
              opacity: 0.2;
            }
          }
          .tab3-img {
            position: absolute;
            z-index: 2;
            width: 100%;
            height: 100%;
            .image {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .bottom-box {
        padding: 0 15px;
        border-top: 1px solid #e3e4e5;
        line-height: 24px;
        display: flex;
        align-items: center;
        .mini-logo {
          width: 14px;
          height: 14px;
          display: inline-block;
          margin-right: 3px;
        }
      }
    }
  }

  .dialog-footer {
    margin-top: 20px;
    text-align: center;
    .closeCancel {
      border: 1px solid #dcdfe6;
      background: #ffffff;
      color: #606266;
    }
    .closeCancel:hover {
      background: rgba(0, 0, 0, 0.04);
      color: #606266;
    }
  }
  .dialog-footer ::v-deep .el-button span {
    font-weight: normal;
  }
}
.el-button--primary:hover {
  background: #63b0ff;
  color: #ffffff;
}
.release-dialog {
  ::v-deep .el-dialog {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    margin-top: 0 !important;
  }
}
</style>
